import { LazyLoadedStates, LazyLoadedStatesManager } from "@edl-development/edl-common";
import { CplItemSubmissionStatusFilter } from "../supervision-management/enums/cpl-item-submission-status-filter.enum";

export const ComplianceItemsLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    view: LazyLoadedStates,
    search: LazyLoadedStates,
    mySupItems: LazyLoadedStates,
    mySupItemsAll: LazyLoadedStates,
    mySupItemsSearch: LazyLoadedStates,
    templates: LazyLoadedStates,
    add: LazyLoadedStates,
    cplItem: LazyLoadedStates,
    cplItemRoster: LazyLoadedStates,
    cplItemRosterSearch: LazyLoadedStates,
    cplItemRosterCycle: LazyLoadedStates,
    cplItemRosterHistory: LazyLoadedStates,
    cplItemEdit: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.compliance-items',
        url: '/compliance-items',
        abstract: true
    },
    view: {
        name: 'authenticated.compliance-items.view',
        url: '/view/:page?orderBy&ascending'
    },
    search: {
        name: 'authenticated.compliance-items.search',
        url: '/search/:page?orderBy&ascending&status&searchBy&tag&itemsBy&itemPackets&submissionStatus',
        params: {
            status: {
                type: 'int'
            },
            tag: {
                type: 'int'
            },
            searchBy: {
                raw: true,
                value: '',
            },
            submissionStatus: {
                type: 'int',
                value: CplItemSubmissionStatusFilter.ALL
            }
        }
    },
    mySupItems: {
        name: 'authenticated.compliance-items.my-supervision-items',
        url: '/my-supervision-items'
    },
    mySupItemsAll: {
        name: 'authenticated.compliance-items.my-supervision-items.all',
        url: '/view/:page?orderBy&ascending'
    },
    mySupItemsSearch: {
        name: 'authenticated.compliance-items.my-supervision-items.search',
        url: '/search/:page?orderBy&ascending&status&searchBy&tag&itemsBy&itemPackets&submissionStatus',
        params: {
            status: {
                type: 'int'
            },
            tag: {
                type: 'int'
            },
            searchBy: {
                raw:true,
                value: '',
            },
            submissionStatus: {
                type: 'int',
                value: CplItemSubmissionStatusFilter.ALL
            }
        }
    },
    templates: {
        name: 'authenticated.compliance-items.templates',
        url: '/templates/:page?orderBy&ascending&status&searchBy&tag&itemsBy',
        params: {
            status: {
                type: 'int'
            },
            tag: {
                type: 'int'
            },
            searchBy: {
                raw: true,
                value: '',
            },
        }
    },
    add: {
        name: 'authenticated.compliance-items.add',
        url: '/add'
    },
    cplItem: {
        name: 'authenticated.compliance-items.compliance-item',
        abstract: true,
        url: '/:complianceItemId'
    },
    cplItemRoster: {
        name: 'authenticated.compliance-items.compliance-item.roster',
        url: '/:page'
    },
    cplItemRosterSearch: {
        name: 'authenticated.compliance-items.compliance-item.roster.search',
        url: '/:page/:itemCycleID?statusId&searchBy&act48Status&approverUserId&groupIds',
        params: {
            searchBy: {
                raw: true,
                value: '',
            },
            groupIds: {
                array: true
            }
        }
    },
    cplItemRosterCycle:{
        name: 'authenticated.compliance-items.compliance-item.roster.cycle',
        url: '/:itemCycleID'
    },
    cplItemRosterHistory: {
        name: 'authenticated.compliance-items.compliance-item.roster.history',
        url: '/history/:userId/:historyPage'
    },
    cplItemEdit: {
        name: 'authenticated.compliance-items.compliance-item.edit',
        url: '/edit'
    }
},
() => import('src/app/supervision-management/compliance-items.module').then(mod => mod.ComplianceItemsModule)
);
